import { Injectable, Signal, signal } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private _processing$ = signal<boolean>(false);
    private _loading$ = signal<boolean>(false);

    get processing$(): Signal<boolean> {
        return this._processing$.asReadonly();
    }

    get loading$(): Signal<boolean> {
        return this._loading$.asReadonly();
    }

    startProcessing(): void {
        this._processing$.set(true);
    }

    stopProcessing(): void {
        this._processing$.set(false);
    }

    startLoading(): void {
        this._loading$.set(true);
    }

    stopLoading(): void {
        this._loading$.set(false);
    }
}